module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-6-mobile-bb2d3d4d578c814c87f80f8affabf6d8.png";